// TODO будет получение tabs из userStore, но пока необходимы статичные вкладки с редиректом в старую систему
import { C300_URL } from '../../../../../../constants';

export const tabsMenuFirstLevel = [
  {
    title: 'Список МКД',
    linkUrl: `${C300_URL}provider_addresses`,
    slug: 'house',
  },
  { title: 'Организации', linkUrl: null, slug: 'providers' },
  { title: 'Сотрудники', linkUrl: `${C300_URL}workers`, slug: 'hr' },
  { title: 'Тарифы', linkUrl: null, slug: 'tariffs' },
  { title: 'Оплаты', linkUrl: null, slug: 'payments' },
  { title: 'Начисления', linkUrl: null, slug: 'accruals_management' },
  { title: 'Отчеты', linkUrl: null, slug: 'all_reports' },
  { title: 'Статистика', linkUrl: null, slug: 'statistics' },
  { title: 'Журнал заявок', routeName: 'requests', slug: 'request_log' },
  { title: 'Обращения', linkUrl: null, slug: 'tickets' }, // TODO: заменить, когда изменится на appeals
  { title: 'Сообщения', linkUrl: `${C300_URL}support/list`, slug: 'all' },
  { title: 'Телефония', routeName: 'telephony', slug: 'calls' },
  {
    title: 'Документооборот',
    routeName: 'documents_flow',
    slug: 'documents',
  },
  {
    title: 'Клиентские ошибки',
    linkUrl: `${C300_URL}errors`,
    slug: 'client_errors',
  },
  {
    title: 'Домовые чаты',
    routeName: 'house_chats',
    slug: 'house_chats',
  },
  {
    title: 'Новости',
    routeName: 'news',
    slug: 'news',
    // onlyForProviders: [
    //   ProvidersIds.ROSCLUSTER_ID,
    //   '526234b3e0e34c4743822066',
    //   '61b06a693b6d6e0019260942',
    // ],
  },
  { title: 'Справочники', linkUrl: null, slug: 'catalogs' },
  { title: 'Склад', linkUrl: null, slug: 'storage' },
  {
    title: 'Автоматизация',
    linkUrl: null,
    slug: 'automation',
  },
  {
    title: 'Управленческий учет',
    routeName: 'management_accounting',
    slug: 'management_accounting',
  },
  // {title: 'Телефония', linkUrl: `${defaultUrl}telephony/history`, slug: 'telephony'},
  {
    title: 'Плановые работы',
    linkUrl: `${C300_URL}plannedworks`,
    slug: 'planned_works',
  },
  { title: 'Настройки', linkUrl: null, slug: 'settings' },
  {
    title: 'База знаний',
    linkUrl: `${C300_URL}knowledge_base`,
    slug: 'knowledge_base',
  },
  { title: 'ГИС ЖКХ', linkUrl: null, slug: 'gis_zkh' },
  { title: 'Очередь задач', linkUrl: null, slug: 'processing_tasks' },
  { title: 'Управление сайтом', linkUrl: null, slug: 'site' },
  {
    title: 'Интеграция с 1С',
    linkUrl: `${C300_URL}integration`,
    slug: 'module_1c',
  },
  { title: 'UI library', routeName: 'ui_lib', slug: '' },
];

export const tabsMenuSecondLevel = [
  {
    title: 'Список организаций',
    linkUrl: `${C300_URL}providers/list`,
    parent_slug: 'providers',
    slug: 'providers_list',
  },
  {
    title: 'Статистика по статусам',
    linkUrl: `${C300_URL}providers/providers_statuses`,
    parent_slug: 'providers',
    slug: 'providers_statuses',
  },
  {
    title: 'Совершенные действия',
    linkUrl: `${C300_URL}providers/actions`,
    parent_slug: 'providers',
    slug: 'all_providers_done',
  },
  {
    title: 'Запланированные действия',
    linkUrl: `${C300_URL}providers/events`,
    parent_slug: 'providers',
    slug: 'all_providers_planned',
  },
  {
    title: 'Журнал обзвона',
    linkUrl: `${C300_URL}providers/calls_log`,
    parent_slug: 'providers',
    slug: 'calls_log',
  }, // TODO calls_log Отчеты
  {
    title: 'Архив обзвона',
    linkUrl: `${C300_URL}providers/calls_archive`,
    parent_slug: 'providers',
    slug: 'calls_archive',
  }, // TODO calls_archive Отчеты
  {
    title: 'Отчет по CRM',
    linkUrl: `${C300_URL}providers/report_crm`,
    parent_slug: 'providers',
    slug: 'report_crm',
  },
  {
    title: 'Мониторинг',
    linkUrl: `${C300_URL}providers/activity`,
    parent_slug: 'providers',
    slug: 'providers_activity',
  },
  {
    title: 'Организации на карте',
    linkUrl: `${C300_URL}providers/providers_map`,
    parent_slug: 'providers',
    slug: 'providers_map',
  },
  {
    title: 'Работа тех. поддержки',
    linkUrl: `${C300_URL}providers/supportTimer`,
    parent_slug: 'providers',
    slug: 'supportTimer',
  },
  {
    title: 'Рейтинг руководителей',
    linkUrl: `${C300_URL}providers/area_rating`,
    parent_slug: 'providers',
    slug: 'providers_area_rating',
  },
  {
    title: 'Документооборот',
    linkUrl: `${C300_URL}providers/clients_offsets`,
    parent_slug: 'providers',
    slug: 'clients_offsets',
  },
  {
    title: 'Тарифные планы',
    linkUrl: `${C300_URL}tariffs`,
    parent_slug: 'tariffs',
    slug: 'tariff_plans',
  },
  {
    title: 'Пользовательские виды платежей',
    linkUrl: `${C300_URL}tariffs/service_types`,
    parent_slug: 'tariffs',
    slug: 'Tariffs_service_types',
  },
  {
    title: 'Документы оплат',
    linkUrl: `${C300_URL}payments/list`,
    parent_slug: 'payments',
    slug: 'payment_docs_list',
  },
  {
    title: 'Чеки реализации',
    linkUrl: `${C300_URL}payments/sales_receipts`,
    parent_slug: 'payments',
    slug: 'sales_receipts',
  },
  {
    title: 'Расчёты с поставщиками',
    linkUrl: `${C300_URL}payments/contractors_calculations`,
    parent_slug: 'payments',
    slug: 'contractors_calculations',
  },
  {
    title: 'Сторно',
    linkUrl: `${C300_URL}payments/storno`,
    parent_slug: 'payments',
    slug: 'storno',
  },
  {
    title: 'Сверка по банковской выписке',
    linkUrl: `${C300_URL}payments/ordering`,
    parent_slug: 'payments',
    slug: 'ordering',
  },
  {
    title: 'Загрузка выписок',
    linkUrl: `${C300_URL}payments/paymentsTasks`,
    parent_slug: 'payments',
    slug: 'paymentsTasks',
  },
  {
    title: 'Невыясненные платежи',
    linkUrl: `${C300_URL}payments/anonymous_payments`,
    parent_slug: 'payments',
    slug: 'anonymous_payments',
  },
  {
    title: 'Расчет начислений',
    linkUrl: `${C300_URL}accruals/management/calculation`,
    parent_slug: 'accruals_management',
    slug: 'am_calculation',
  },
  {
    title: 'Архивы квитанций',
    linkUrl: `${C300_URL}accruals/management/archive`,
    parent_slug: 'accruals_management',
    slug: 'am_archive',
  },
  {
    title: 'Очередь задач',
    linkUrl: `${C300_URL}accruals/management/tasks`,
    parent_slug: 'accruals_management',
    slug: 'am_tasks',
  },
  {
    title: 'Сверка офсетов',
    linkUrl: `${C300_URL}accruals/management/offsets`,
    parent_slug: 'accruals_management',
    slug: 'am_offsets',
  },
  {
    title: 'Офсеты',
    linkUrl: `${C300_URL}accruals/management/new_offsets`,
    parent_slug: 'accruals_management',
    slug: 'accruals_offsets',
  },
  {
    title: 'Оборотно-сальдовая ведомость',
    linkUrl: `${C300_URL}reports/fin_reports/trial_balance`,
    parent_slug: 'all_reports',
    slug: 'trial_balance',
  },
  {
    title: 'ОСВ по услуге',
    linkUrl: `${C300_URL}reports/fin_reports/trial_balance_service`,
    parent_slug: 'all_reports',
    slug: 'trial_balance_service',
  },
  {
    title: 'Отчёт о фактическом объёме поставленных услуг',
    linkUrl: `${C300_URL}reports/fin_reports/system_communal_resources`,
    parent_slug: 'all_reports',
    slug: 'system_communal_resources',
  },
  {
    title: 'Акт о фактическом объеме поставленных услуг',
    linkUrl: `${C300_URL}reports/fin_reports/act_of_resources`,
    parent_slug: 'all_reports',
    slug: 'act_of_resources',
  },
  {
    title: 'Отчет по оплате по дням',
    linkUrl: `${C300_URL}reports/fin_reports/vendors_payments`,
    parent_slug: 'all_reports',
    slug: 'vendors_payments',
  },
  {
    title: 'Сводный отчет по оплате по дням',
    linkUrl: `${C300_URL}reports/fin_reports/vendors_payments_houses`,
    parent_slug: 'all_reports',
    slug: 'vendors_payments_houses',
  },
  {
    title: 'ОСВ по поставщикам',
    linkUrl: `${C300_URL}reports/fin_reports/contractors_osv`,
    parent_slug: 'all_reports',
    slug: 'contractors_osv',
  },
  {
    title: 'Оплаты по поставщикам',
    linkUrl: `${C300_URL}reports/fin_reports/contractors_payments`,
    parent_slug: 'all_reports',
    slug: 'contractors_payments',
  },
  {
    title: 'Сверка по оплатам и чекам',
    linkUrl: `${C300_URL}reports/fin_reports/verify_payments_receipts`,
    parent_slug: 'all_reports',
    slug: 'verify_payments_receipts',
  },
  {
    title: 'Список должников',
    linkUrl: `${C300_URL}reports/fin_reports/debtors`,
    parent_slug: 'all_reports',
    slug: 'debtors_report',
  },
  {
    title: 'Список должников',
    linkUrl: `${C300_URL}reports/fin_reports/debtors_phones`,
    parent_slug: 'all_reports',
    slug: 'debtors_report_copy',
  }, // x2
  {
    title: 'Досудебная работа',
    linkUrl: `${C300_URL}reports/fin_reports/judicial_work`,
    parent_slug: 'all_reports',
    slug: 'judicial_work',
  },
  {
    title: 'Судебные дела',
    linkUrl: `${C300_URL}reports/fin_reports/court_cases`,
    parent_slug: 'all_reports',
    slug: 'court_cases',
  },
  {
    title: 'Обзвон должников',
    linkUrl: `${C300_URL}reports/fin_reports/call_debtors`,
    parent_slug: 'all_reports',
    slug: 'call_debtors',
  },
  {
    title: 'Задания на обзвон',
    linkUrl: `${C300_URL}reports/fin_reports/call_debtors_tasks`,
    parent_slug: 'all_reports',
    slug: 'call_debtors_tasks',
  },
  {
    title: 'Форма 22',
    linkUrl: `${C300_URL}reports/fin_reports/form_22`,
    parent_slug: 'all_reports',
    slug: 'form_22',
  },
  {
    title: 'Ведомость начислений по жителям',
    linkUrl: `${C300_URL}reports/fin_reports/statement_charges_tenants`,
    parent_slug: 'all_reports',
    slug: 'statement_charges_tenants',
  },
  {
    title: 'Ведомость начислений оплат задолженности за ЖКУ',
    linkUrl: `${C300_URL}reports/fin_reports/splitting_payments_accruals_by_contractors`,
    parent_slug: 'all_reports',
    slug: 'splitting_payments_accruals_by_contractors',
  },
  {
    title: 'Ведомость начислений по домам',
    linkUrl: `${C300_URL}reports/fin_reports/statement_charges_houses`,
    parent_slug: 'all_reports',
    slug: 'statement_charges_houses',
  },
  {
    title: 'Отчет по антеннам и радиоточкам',
    linkUrl: `${C300_URL}reports/fin_reports/antenna`,
    parent_slug: 'all_reports',
    slug: 'antenna_radio_report',
  },
  {
    title: 'Коммунальные услуги по домам',
    linkUrl: `${C300_URL}reports/fin_reports/communal_resources_houses`,
    parent_slug: 'all_reports',
    slug: 'communal_resources_houses_report',
  },
  {
    title: 'Коммунальные услуги',
    linkUrl: `${C300_URL}reports/fin_reports/communal_resources`,
    parent_slug: 'all_reports',
    slug: 'communal_resources_report',
  },
  {
    title: 'Зарегистрированные и проживающие',
    linkUrl: `${C300_URL}reports/fin_reports/registered_and_living`,
    parent_slug: 'all_reports',
    slug: 'registered_living_report',
  },
  {
    title: 'Расщепление платежей',
    linkUrl: `${C300_URL}reports/fin_reports/splitting_payments`,
    parent_slug: 'all_reports',
    slug: 'splitting_payments',
  },
  {
    title: 'Расщепление платежей по банку',
    linkUrl: `${C300_URL}reports/fin_reports/splitting_payments_by_banks`,
    parent_slug: 'all_reports',
    slug: 'splitting_payments_by_banks',
  },
  {
    title: 'Расщепление платежей по банку (нов)',
    linkUrl: `${C300_URL}reports/fin_reports/services_trial_balance`,
    parent_slug: 'all_reports',
    slug: 'services_trial_balance',
  },
  {
    title: 'Расщепление платежей по поставщикам',
    linkUrl: `${C300_URL}reports/fin_reports/splitting_payments_by_contractors`,
    parent_slug: 'all_reports',
    slug: 'splitting_payments_by_contractors',
  },
  {
    title: 'Анализ задолженности',
    linkUrl: `${C300_URL}reports/fin_reports/trial_balance_monthly`,
    parent_slug: 'all_reports',
    slug: 'trial_balance_monthly',
  },
  {
    title: 'Отчет по лицевым счетам',
    linkUrl: `${C300_URL}reports/fin_reports/accounts_report`,
    parent_slug: 'all_reports',
    slug: 'accounts_report',
  },
  {
    title: 'Плановые работы',
    linkUrl: `${C300_URL}reports/fin_reports/planned_work_report`,
    parent_slug: 'all_reports',
    slug: 'planned_work_report',
  },
  {
    title: 'Сводный отчет по домам',
    linkUrl: `${C300_URL}reports/fin_reports/overall_report`,
    parent_slug: 'all_reports',
    slug: 'overall_report',
  },
  {
    title: 'Просроченные счетчики',
    linkUrl: `${C300_URL}reports/fin_reports/overdue_meters_report`,
    parent_slug: 'all_reports',
    slug: 'overdue_meters_report',
  },
  {
    title: 'Просроченные счетчики (новые)',
    routeName: 'reports',
    childName: 'overdue_meters',
    parent_slug: 'all_reports',
    slug: 'overdue_meters_report',
  },
  {
    title: 'Закрытые счётчики',
    linkUrl: `${C300_URL}reports/fin_reports/closed_meters_report`,
    parent_slug: 'all_reports',
    slug: 'closed_meters_report',
  },
  {
    title: 'Несданные показания',
    linkUrl: `${C300_URL}reports/fin_reports/sit_meter_reading`,
    parent_slug: 'all_reports',
    slug: 'sit_meter_reading',
  },
  {
    title: 'Отчет по оплаченным пеням',
    linkUrl: `${C300_URL}reports/fin_reports/payment_penalties`,
    parent_slug: 'all_reports',
    slug: 'payment_penalties',
  },
  {
    title: 'Начисления по статьям',
    linkUrl: `${C300_URL}reports/fin_reports/month_accruals_by_tariffs`,
    parent_slug: 'all_reports',
    slug: 'month_accruals_by_tariffs',
  },
  {
    title: 'Поступления на кап. ремонт',
    linkUrl: `${C300_URL}reports/fin_reports/overhaul_payments`,
    parent_slug: 'all_reports',
    slug: 'overhaul_payments',
  },
  {
    title: 'Отчет о заселении',
    linkUrl: `${C300_URL}reports/fin_reports/settlement`,
    parent_slug: 'all_reports',
    slug: 'settlement',
  },
  {
    title: 'Начисления и оплаты',
    linkUrl: `${C300_URL}reports/fin_reports/municipality`,
    parent_slug: 'all_reports',
    slug: 'municipality',
  },
  {
    title: 'Реализация программы кап. ремонта',
    linkUrl: `${C300_URL}reports/fin_reports/overhaul_information`,
    parent_slug: 'all_reports',
    slug: 'overhaul_information',
  },
  {
    title: 'Тарифы МКД для ФКР',
    linkUrl: `${C300_URL}reports/fin_reports/overhaul_information_part1`,
    parent_slug: 'all_reports',
    slug: 'overhaul_information_part1',
  },
  {
    title: 'Поступления взносов для ФКР',
    linkUrl: `${C300_URL}reports/fin_reports/overhaul_information_part2`,
    parent_slug: 'all_reports',
    slug: 'overhaul_information_part2',
  },
  {
    title: 'Статистика заявок',
    linkUrl: `${C300_URL}reports/req_reports/requests_stats`,
    parent_slug: 'all_reports',
    slug: 'requests_stats',
  },
  {
    title: 'Отчет по заявкам',
    linkUrl: `${C300_URL}reports/req_reports/workload`,
    parent_slug: 'all_reports',
    slug: 'workload_report',
  },
  {
    title: 'Отчет по заявкам (новый)',
    routeName: 'reports',
    childName: 'requests',
    parent_slug: 'all_reports',
    slug: 'workload_report',
  },
  {
    title: 'Отчет по отключениям',
    linkUrl: `${C300_URL}reports/req_reports/report_disconnections`,
    parent_slug: 'all_reports',
    slug: 'report_disconnections',
  },
  {
    title: 'Отчет об оказанных услугах',
    linkUrl: `${C300_URL}reports/storage_reports/performed_services`,
    parent_slug: 'all_reports',
    slug: 'performed_services_report',
  },
  {
    title: 'Объемы на СОИ',
    linkUrl: `${C300_URL}reports/fin_reports/maintenance_common_property`,
    parent_slug: 'all_reports',
    slug: 'maintenance_common_property',
  },
  {
    title: 'Заявки',
    linkUrl: `${C300_URL}statistics/requests`,
    parent_slug: 'statistics',
    slug: 'statistics_requests',
  },
  {
    title: 'Начисления и оплата',
    linkUrl: `${C300_URL}statistics/payments`,
    parent_slug: 'statistics',
    slug: 'statistics_payments',
  },
  {
    title: 'Дома',
    linkUrl: `${C300_URL}statistics/houses`,
    parent_slug: 'statistics',
    slug: 'statistics_houses',
  },
  {
    title: 'Обращения от жителей',
    routeName: 'appeals',
    childName: 'list',
    parent_slug: 'tickets', // TODO: заменить, когда изменится на appeals
    slug: 'tickets_from_tenants',
  },
  {
    title: 'Права на контроль',
    routeName: 'appeals',
    childName: 'management',
    parent_slug: 'tickets', // TODO: заменить, когда изменится на appeals
    slug: 'tickets_management', // TODO: заменить, когда изменится на appeals
  },
  {
    title: 'Список новостей',
    linkUrl: `${C300_URL}news/newsList`,
    parent_slug: 'news',
    slug: 'news_list',
  },
  {
    title: 'Рассылка',
    linkUrl: `${C300_URL}news/delivery`,
    parent_slug: 'news',
    slug: 'delivery',
  },
  {
    title: 'Рассылка писем',
    linkUrl: `${C300_URL}news/mail_shooter`,
    parent_slug: 'news',
    slug: 'mail_shooter',
  },
  {
    title: 'Материалы',
    linkUrl: `${C300_URL}catalogs/materials`,
    parent_slug: 'catalogs',
    slug: 'materials',
  },
  {
    title: 'Услуги',
    linkUrl: `${C300_URL}catalogs/services`,
    parent_slug: 'catalogs',
    slug: 'services',
  },
  {
    title: 'Позиции',
    linkUrl: `${C300_URL}catalogs/shop`,
    parent_slug: 'catalogs',
    slug: 'catalogue_cabinet_positions',
  },
  {
    title: 'Каталог',
    linkUrl: `${C300_URL}catalogs/cabinet_compendium`,
    parent_slug: 'catalogs',
    slug: 'compendium',
  },
  {
    title: 'Поставщики',
    linkUrl: `${C300_URL}catalogs/contractors`,
    parent_slug: 'catalogs',
    slug: 'contractors',
  },
  {
    title: 'Прайс лист',
    linkUrl: `${C300_URL}catalogs/pricelist`,
    parent_slug: 'catalogs',
    slug: 'price_list',
  },
  {
    title: 'Работы по тек ремонту',
    linkUrl: `${C300_URL}catalogs/repairworks`,
    parent_slug: 'catalogs',
    slug: 'repair_works',
  },
  {
    title: 'Тарифы',
    linkUrl: `${C300_URL}catalogs/tariffs`,
    parent_slug: 'catalogs',
    slug: 'system_tariffs',
  },
  {
    title: 'Льготы',
    linkUrl: `${C300_URL}catalogs/privilegesdict`,
    parent_slug: 'catalogs',
    slug: 'privileges_dict',
  },
  {
    title: 'Шаблоны льгот',
    linkUrl: `${C300_URL}catalogs/privilegetmpls`,
    parent_slug: 'catalogs',
    slug: 'privilege_templates',
  },
  {
    title: 'Льготники',
    linkUrl: `${C300_URL}catalogs/exempts_list`,
    parent_slug: 'catalogs',
    slug: 'exempts_list',
  },
  {
    title: 'Справочник Банков',
    linkUrl: `${C300_URL}catalogs/banks`,
    parent_slug: 'catalogs',
    slug: 'bank_catalogs',
  },
  {
    title: 'ФИАС',
    linkUrl: `${C300_URL}catalogs/addresses`,
    parent_slug: 'catalogs',
    slug: 'fias',
  },
  {
    title: 'Котельные',
    linkUrl: `${C300_URL}catalogs/boilers/list`,
    parent_slug: 'catalogs',
    slug: 'boilers',
  },
  {
    title: 'Справочник судов',
    linkUrl: `${C300_URL}catalogs/courts`,
    parent_slug: 'catalogs',
    slug: 'courts_list',
  },
  {
    title: 'Остатки',
    linkUrl: `${C300_URL}storage/balance`,
    parent_slug: 'storage',
    slug: 'storage_balance',
  },
  {
    title: 'Движения',
    linkUrl: `${C300_URL}storage/dynamics`,
    parent_slug: 'storage',
    slug: 'dynamics',
  },
  {
    title: 'Приходные ордеры',
    linkUrl: `${C300_URL}storage/vouchers`,
    parent_slug: 'storage',
    slug: 'inventory_vouchers',
  },
  {
    title: 'Перемещения',
    linkUrl: `${C300_URL}storage/movement_docs`,
    parent_slug: 'storage',
    slug: 'movement_docs',
  },
  {
    title: 'Список складов',
    linkUrl: `${C300_URL}storage/storages_list`,
    parent_slug: 'storage',
    slug: 'storages_list',
  },
  {
    title: 'Списание материалов',
    linkUrl: `${C300_URL}storage/write_off_material`,
    parent_slug: 'storage',
    slug: 'write_off_material',
  },
  {
    title: 'Движение ТМЦ',
    linkUrl: `${C300_URL}storage/movement_tmc`,
    parent_slug: 'storage',
    slug: 'movement_tmc',
  },
  {
    title: 'Результаты опроса ПУ',
    routeName: 'automation',
    childName: 'automation_result',
    parent_slug: 'automation',
    slug: 'automation',
  },
  {
    title: 'Отчеты о теплопотреблении',
    routeName: 'automation',
    childName: 'heat_consumption',
    parent_slug: 'automation',
    slug: 'heat_consumption_report',
  },
  {
    title: 'Журнал опроса счетчиков МКД',
    routeName: 'automation',
    childName: 'raspberry_tasks',
    parent_slug: 'automation',
    slug: 'raspberry_tasks',
  },
  {
    title: 'Отчет о тепловых параметрах МКД',
    routeName: 'automation',
    childName: 'melt_down',
    parent_slug: 'automation',
    slug: 'melt_down',
  },
  {
    title: 'Настройки объектов',
    routeName: 'automation',
    childName: 'resources_settings',
    parent_slug: 'automation',
    slug: 'automation',
  },
  {
    title: 'Бухгалтерия',
    linkUrl: `${C300_URL}settings/accounting`,
    parent_slug: 'settings',
    slug: 'settings_accounting',
  },
  {
    title: 'Группировка домов',
    linkUrl: `${C300_URL}settings/groups_houses`,
    parent_slug: 'settings',
    slug: 'groups_houses',
  },
  {
    title: 'Редактор бланков',
    linkUrl: `${C300_URL}settings/blanks`,
    parent_slug: 'settings',
    slug: 'settings_blanks',
  },
  {
    title: 'Расчет',
    linkUrl: `${C300_URL}settings/recalculation`,
    parent_slug: 'settings',
    slug: 'calculation_settings',
  },
  {
    title: 'Выгрузка в ГЦЖС',
    linkUrl: `${C300_URL}settings/gcjs`,
    parent_slug: 'settings',
    slug: 'settings_gcjs',
  },
  {
    title: 'Бланки',
    linkUrl: `${C300_URL}settings/blanksChoose`,
    parent_slug: 'settings',
    slug: 'settings_blanks_choose',
  },
  {
    title: 'Настройка бланков',
    linkUrl: `${C300_URL}settings/blank_settings`,
    parent_slug: 'settings',
    slug: 'blank_settings',
  },
  {
    title: 'Шаблон импорта льготников',
    linkUrl: `${C300_URL}settings/privileged`,
    parent_slug: 'settings',
    slug: 'settings_privileged',
  },
  {
    title: 'Вкладки',
    linkUrl: `${C300_URL}settings/tabs`,
    parent_slug: 'settings',
    slug: 'tabs_admin',
  },
  {
    title: 'Виды деятельности',
    linkUrl: `${C300_URL}settings/business_type_rights`,
    parent_slug: 'settings',
    slug: 'business_type_rights',
  },
  {
    title: 'Кристалл',
    routeName: 'settings',
    childName: 'crystal',
    parent_slug: 'settings',
    slug: 'signal',
  },
  {
    title: 'Выгрузка шаблонов Excel',
    linkUrl: `${C300_URL}gis/exchange_excel`,
    parent_slug: 'gis_zkh',
    slug: 'exchange_excel',
  },
  {
    title: 'Настройки обмена с ГИС',
    linkUrl: `${C300_URL}gis/sharing_settings`,
    parent_slug: 'gis_zkh',
    slug: 'sharing_settings',
  },
  {
    title: 'Обмен с ГИС',
    linkUrl: `${C300_URL}gis/exchange_log`,
    parent_slug: 'gis_zkh',
    slug: 'exchange_log',
  },
  {
    title: 'Ошибки обмена ГИС ЖКХ',
    linkUrl: `${C300_URL}gis/exchange_errors`,
    parent_slug: 'gis_zkh',
    slug: 'exchange_errors',
  },
  {
    title: 'Сопоставление услуг',
    linkUrl: `${C300_URL}gis/service_matching`,
    parent_slug: 'gis_zkh',
    slug: 'service_matching',
  },
  {
    title: 'Обслуживание',
    linkUrl: `${C300_URL}processing/maintenance`,
    parent_slug: 'processing_tasks',
    slug: 'processing_maintenance',
  },
  {
    title: 'Восстановление данных',
    linkUrl: `${C300_URL}processing/recovery_data`,
    parent_slug: 'processing_tasks',
    slug: 'recovery_data',
  },
  {
    title: 'Массовое изменение данных',
    linkUrl: `${C300_URL}processing/datachanges`,
    parent_slug: 'processing_tasks',
    slug: 'processing_datachanges',
  },
  {
    title: 'Трекер автоматизации',
    linkUrl: `${C300_URL}processing/automation`,
    parent_slug: 'processing_tasks',
    slug: 'automation_statistic',
  },
  {
    title: 'Фискализация',
    linkUrl: `${C300_URL}processing/fiscal_registration`,
    parent_slug: 'processing_tasks',
    slug: 'fiscal_registration_monitor',
  },
  {
    title: 'Мониторинг фискализации',
    linkUrl: `${C300_URL}processing/fisc_monitor`,
    parent_slug: 'processing_tasks',
    slug: 'fisc_monitor',
  },
  {
    title: 'ГИС',
    linkUrl: `${C300_URL}processing/gis_record`,
    parent_slug: 'processing_tasks',
    slug: 'gis_record',
  },
  {
    title: 'Основное',
    linkUrl: `${C300_URL}client_admin/organization_info`,
    parent_slug: 'site',
    slug: 'site-organization_info',
  },
  {
    title: 'Стартовая',
    linkUrl: `${C300_URL}client_admin/start_page_content`,
    parent_slug: 'site',
    slug: 'site-start_page_content',
  },
  {
    title: 'Новости',
    linkUrl: `${C300_URL}client_admin/news`,
    parent_slug: 'site',
    slug: 'site-news',
  },
  {
    title: 'Руководство',
    linkUrl: `${C300_URL}client_admin/management`,
    parent_slug: 'site',
    slug: 'site-management',
  },
  {
    title: 'Обслуживаемые дома',
    linkUrl: `${C300_URL}client_admin/houses`,
    parent_slug: 'site',
    slug: 'site-houses',
  },
  {
    title: 'Обслуживание прекращено',
    linkUrl: `${C300_URL}client_admin/lost_houses`,
    parent_slug: 'site',
    slug: 'site-lost_houses',
  },
  {
    title: 'Информация о доме',
    linkUrl: `${C300_URL}client_admin/house_info`,
    parent_slug: 'site',
    slug: 'site-house_info',
  },
  {
    title: 'Документы',
    linkUrl: `${C300_URL}client_admin/documents`,
    parent_slug: 'site',
    slug: 'site-documents',
  },
  {
    title: 'Нарушения',
    linkUrl: `${C300_URL}client_admin/contraventions`,
    parent_slug: 'site',
    slug: 'site-contraventions',
  },
  {
    title: 'Список должников',
    linkUrl: `${C300_URL}client_admin/debtors`,
    parent_slug: 'site',
    slug: 'site-debtors',
  },
  {
    title: 'Полезные ссылки',
    linkUrl: `${C300_URL}client_admin/useful_info`,
    parent_slug: 'site',
    slug: 'site-useful_info',
  },
  {
    title: 'События',
    linkUrl: `${C300_URL}client_admin/events`,
    parent_slug: 'site',
    slug: 'site-events',
  },
  {
    title: 'Услуги',
    linkUrl: `${C300_URL}client_admin/services`,
    parent_slug: 'site',
    slug: 'site-services',
  },
  {
    title: 'Собрания',
    linkUrl: `${C300_URL}client_admin/meetings`,
    parent_slug: 'site',
    slug: 'site-meetings',
  },
];
